import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import cn from 'classnames';
import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { IHeaderConfig } from 'utils/globalTypes';
import { useScrollActions } from 'utils/hooks/useScrollActions';

import s from './Header.module.scss';
import HeaderOffering from './HeaderOffering';

type Header = {
  children: React.ReactNode;
  isSticky?: boolean;
  pathName?: string;
  className?: string;
  headerConfig?: IHeaderConfig;
  isManagement?: boolean;
};

const TIMEOUT = 200;

const Header = ({
  children,
  isSticky,
  pathName,
  headerConfig,
  isManagement,
  className
}: Header) => {
  const nodeRef = useRef(null);
  const { isElementReached } = useScrollActions('#OfferingDetailsWrapperBox');
  const showOfferingHeader = !!(isElementReached && headerConfig?.transformation === 'offering');

  return (
    <header
      className={cn(s.Header, className, {
        isSticky,
        isManagement,
        transparent: headerConfig?.transparent,
        isCompoundHeader: headerConfig?.isCompoundHeader,
        isBrowsing: headerConfig?.isBrowsing || pathName?.startsWith('/marketplace'),
        isPortfolio:
          headerConfig?.isPortfolio ||
          pathName?.startsWith('/portfolio') ||
          pathName?.startsWith('/admin')
      })}
    >
      <CSSTransition
        nodeRef={nodeRef}
        timeout={TIMEOUT}
        in={!showOfferingHeader}
        unmountOnExit
        classNames="HeaderDefault"
      >
        <Box ref={nodeRef} sx={{ width: '100%' }}>
          {children}
        </Box>
      </CSSTransition>
      <Fade timeout={TIMEOUT} in={showOfferingHeader} unmountOnExit>
        <HeaderOffering />
      </Fade>
    </header>
  );
};

export default Header;
